<template>
  <div class="account-controls">
    <div class="account-controls__icon">
      <img
        v-if="contactPhoto"
        :src="contactPhoto"
        class="account-controls__image"
        heigt="24"
        width="24"
      />
      <span v-else class="account-controls__initials">{{ userInitials }}</span>
    </div>
  </div>
</template>

<script>
// Constants
import { GETTER } from '@/store/CONSTANTS';

export default {
  name: 'AccountControls',
  computed: {
    contactPhoto() {
      return this.$store.getters[GETTER.USER.CONTACT_PHOTO];
    },
    userInitials() {
      return this.$store.getters[GETTER.USER.INITIALS];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

$transition-duration: 150ms;

.account-controls {
  $root: &;

  position: relative;

  &__icon {
    display: flex;
    align-items: flex-end;
  }

  &__image,
  &__initials {
    border-radius: 50%;
    height: 24px;
    overflow: hidden;
    width: 24px;
  }

  &__image {
    background-color: $primary-bg;
    object-fit: cover;
  }

  &__initials {
    @include font('DS-80');
    align-items: center;
    background-color: getShade($secondary-color, 110);
    color: $primary-bg;
    display: flex;
    justify-content: center;
    font-family: $font-primary;
    font-weight: 600;
    text-transform: uppercase;
  }
}
</style>
